<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
  import {getCookie} from '@/helpers/getCookie.js'

  export default {
    name: 'App',

    components: {},

    data: () => ({
      //
    }),
    mounted: function() {
      let csrf = getCookie("csrftoken")
      if (csrf) {
        this.$store.commit("setCsrf", csrf)
      }
    }
  };
</script>
